import { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import { getClassNames, formatDate } from '../../../../../utils/util';

import DatePicker from '../../date-picker/DatePicker';

import { ReactComponent as ArrowSingle } from '../../../../../resources/icons/arrow-single.svg';

import './date-range-dropdown.scss';

const DateRangeDropdown = ({ fromDate, toDate, onFromDateChange, onToDateChange }) => {
  const [showPickers, setShowPickers] = useState(false);

  const dropdownRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowPickers(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const getDisplayValue = () => {
    if (fromDate && toDate) {
      return `${formatDate(fromDate, false, false, true)} - ${formatDate(toDate, false, false, true)}`;
    }

    return 'Select date range';
  };

  const handleFromDateChange = (date) => {
    onFromDateChange(date);
    setShowPickers(false);
  };

  const handleToDateChange = (date) => {
    onToDateChange(date);
    setShowPickers(false);
  };

  return (
    <div className="date-range-dropdown" ref={dropdownRef}>
      <button className="date-range-dropdown__dates" onClick={() => setShowPickers(!showPickers)}>
        <p>{getDisplayValue()}</p>
        <ArrowSingle className={getClassNames('date-range-dropdown__icon', { open: showPickers })} />
      </button>

      {showPickers && (
        <div className="date-range-dropdown__pickers">
          <div className="date-range-dropdown__picker">
            <label className="date-range-dropdown__picker__label" htmlFor="from-date">
              From
            </label>
            <DatePicker
              name="from-date"
              value={fromDate}
              onChange={(date) => handleFromDateChange(date)}
              maxDate={toDate}
              shortMonth
            />
          </div>
          <div className="date-range-dropdown__picker">
            <label className="date-range-dropdown__picker__label" htmlFor="to-date">
              To
            </label>
            <DatePicker
              name="to-date"
              value={toDate}
              onChange={(date) => handleToDateChange(date)}
              minDate={fromDate}
              shortMonth
            />
          </div>
        </div>
      )}
    </div>
  );
};

DateRangeDropdown.propTypes = {
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  onFromDateChange: PropTypes.func.isRequired,
  onToDateChange: PropTypes.func.isRequired,
};

export default DateRangeDropdown;
